export const ANALYTICS_TAGS = {
  // Login tags
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  LOGIN_IDV_SUCCESS: 'login_idv_success',
  LOGIN_IDV_FAILED: 'login_idv_failed',
  LOGIN_OTP_SUCCESS: 'login_otp_success',
  LOGIN_OTP_FAILED: 'login_otp_failed',
  LOGIN_OTP_RESEND_SUCCESS: 'login_otp_resend_success',
  LOGIN_OTP_RESEND_FAILED: 'login_otp_resend_failed',
  LOGGED_OUT_SUCCESSFUL: 'logged_out_successful',

  // Signup tags
  SIGNUP_SUCCESS: 'signup_success',
  SIGNUP_FAILED: 'signup_failed',

  // OTP tags
  OTP_SUCCESS: 'otp_success',
  OTP_FAILED: 'otp_failed',
  OTP_RESEND_SUCCESS: 'otp_resend_success',
  OTP_RESEND_FAILED: 'otp_resend_failed',

  // Payment plan tags
  PPLAN_STARTED: 'pplan_started',
  PPLAN_COMPLETE: 'pplan_complete',
  REPAYMENT_METHOD: 'repayment_method',

  // Financial statement tags
  SFS_STARTED: 'sfs_started',
  SFS_STEP_CHANGE: 'sfs_step_change',
  SFS_COMPLETED: 'sfs_completed',
};
